import { PropsWithChildren } from 'react';
import { Bottomsheet, Button, HeadTitle, Spacer } from 'oui';
import { FloatingBox, SideBox } from '../LBox/LBox';

interface IBottomSheetTemp extends PropsWithChildren {
  isOpen: boolean;
  title: string;
  subTitle?: string;
  confirmBtn?: {
    isActive: boolean;
    onConfirm: () => void;
  };
  onClickCloseBottomSheet: () => void;
}

const BottomSheetTemp = ({
  isOpen,
  title,
  subTitle,
  confirmBtn,
  onClickCloseBottomSheet,
  children,
}: IBottomSheetTemp) => {
  return (
    <>
      <Bottomsheet isOpen={isOpen} backdrop>
        <HeadTitle
          textTitle={title}
          subTitle={subTitle}
          buttonIconName={'CloseSharp'}
          onClickButton={onClickCloseBottomSheet}
        />
        <Spacer size="xs" />
        <SideBox>{children}</SideBox>
        {confirmBtn && (
          <FloatingBox>
            <Button
              flexible
              configuration={'contained'}
              isDisabled={!confirmBtn.isActive}
              state={!confirmBtn.isActive ? 'disabled' : 'enabled'}
              onClick={confirmBtn.isActive ? confirmBtn.onConfirm : undefined}
            >
              확인
            </Button>
          </FloatingBox>
        )}
      </Bottomsheet>
    </>
  );
};

export default BottomSheetTemp;
